/**
 * Slider
 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import InputRange from 'react-input-range';
require('react-input-range/lib/css/index.css');

class Slider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props ? props.value : ""
    };
  }

 
  onRangeSlideStopped(value, ignoreInteractive) {
    this.setState({value: value});
  };

  render(){
    const _min = parseFloat(this.props.min);
    const _max = parseFloat(this.props.max);
    let _step = this.props.step;
    if(_step !== null && _step !== null && _step !== "") {
      _step = parseFloat(_step);
    } else {
      _step = 1;
    }
    let self = this;
    const _val = parseFloat(this.state.value);
    return (
      <InputRange
        minValue={_min}
        maxValue={_max}
        ref={"input-range"}
        step={_step}
        name={"v-" + this.props.name}
        value={_val}
        onChange={(value) => {
          self.setState({"value":value});
          self.props.onChange(value);
        }}
        onChangeComplete={self.props.onChangeComplete}
      />
    );
  }
}
export default Slider;



